import React, { PureComponent } from 'react';
import {
    LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend,
} from 'recharts';
import './Chart.css'

const data = [
    {
        name: 'March', uv: 2, pv: 2, amt: 2,
    },
    {
        name: 'April', uv: 3, pv: 3, amt: 7,
    },
    {
        name: 'May', uv: 2, pv: 2, amt: 9,
    },
    {
        name: 'June', uv: 2, pv: 1, amt: 5,
    },
    {
        name: 'July', uv: 2, pv: 3, amt: 16,
    },
    {
        name: 'August', uv: 6, pv: 4, amt: 2,
    },
    {
        name: 'September', uv: 13, pv: 1, amt: 15,
    },
];

export default class Chart extends PureComponent {
    static jsfiddleUrl = 'https://jsfiddle.net/alidingling/xqjtetw0/';

    render() {
        return (
            <div className="chart-main-container" >
                <h1>Cases By Month</h1>
                <LineChart
                    width={600}
                    height={350}
                    data={data}
                    margin={{
                        top: 5, right: 5, left: 0, bottom: 5,
                    }}
                >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" />
                    <YAxis />
                    <Tooltip />
                    <Line type="monotone" dataKey="pv" stroke="#8884d8" activeDot={{ r: 8 }} />
                </LineChart>
            </div>
        );
    }
}
